import { useContext } from 'react'

import { ApprovalContext } from '@provider/Mrp/ApprovalProvider'

import { IApprovalContext } from '@base/@types/providers/Mrp/ApprovalProvider'

const useApproval = (): IApprovalContext => {
  const context = useContext(ApprovalContext)

  if (!context) {
    throw new Error('useApproval must be used within an ApprovalProvider')
  }

  return context
}

export default useApproval
